export interface IntroScreenConfig {
  title?: string;
  prompt?: string;
}

export interface DocumentConfig {
  kind: string;
  description: string;
  prompt: string;
  title: string;
  examples?: string[];
  optional?: boolean;
}

export enum DocumentCaptureOption {
  WebCamera = 'web_camera',
  MobileCamera = 'mobile_camera',
  Upload = 'upload',
  ToMobile = 'to_mobile',
}

export interface DocumentConfigDocumentsUpload {
  'enabled-capture-options'?: DocumentCaptureOption[];
  'intro-screen'?: IntroScreenConfig;
  'skip-intro-screen': boolean;
  // TODO: This should be renamed from 'required' to 'documents' but wanted to
  // avoid a data migration since this will be migrated again in Dynamic Flow.
  required: DocumentConfig[];
}
